import { __assign } from "tslib";
import React from 'react';
import LiteratureThumbHtmlView from './LiteratureHtml';
import LiteratureThumbReactView from './Literature';
var LiterartureThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(LiteratureThumbHtmlView, __assign({}, props));
    }
    return React.createElement(LiteratureThumbReactView, __assign({}, props));
};
LiterartureThumbView.displayName = 'LiterartureThumbView';
export default LiterartureThumbView;
//# sourceMappingURL=index.js.map